import type { AnnotationLinkStyle } from 'balus-common';

export const AnnotationLinkStyleI18nKeys = {
  wedge: 'canvas.annotationLink.menu.style.wedge',
  roundDot: 'canvas.annotationLink.menu.style.roundDot',
} as const satisfies Record<AnnotationLinkStyle, string>;
